import React, { useEffect } from "react";
import {
  Container,
  Grid,
  IconButton,
  Link,
  Hidden,
  Button,
  Typography,
  TextField,
  Alert,
} from "@mui/material";

import { useMutation } from "react-query";
import { request, gql } from "graphql-request";
import { useSharedBookReducer } from "../state";

const Promocode = (props) => {
  const [bookState, dispatch] = useSharedBookReducer();

  const setCoupon = (e) => {
    dispatch({
      type: "MERGE",
      payload: {
        m: { coupon: e.target.value },
      },
    });
  };

  const {
    status,
    error,
    data: promocodeByCode,
    mutate: applyPromo,
    isLoading,
    isIdle,
  } = useMutation(async () => {
    dispatch({
      type: "MERGE",
      payload: {
        promo: {
          applying: true,
          applied: false,
          code: null,
          details: null,
        },
      },
    });
    const result = await request(
      "/api/graphql",
      gql`
        query($code: String!) {
          promocodeByCode(code: $code) {
            code
            type
            title
            data
          }
        }
      `,
      {
        code: bookState.m.coupon,
      }
    );
    if (result.promocodeByCode?.data) {
      dispatch({
        type: "MERGE",
        payload: {
          promo: {
            applying: null,
            applied: false,
            code: result.promocodeByCode?.code,
            details: result.promocodeByCode,
          },
        },
      });
    } else {
      dispatch({
        type: "MERGE",
        payload: {
          promo: {
            applying: false,
          },
        },
      });
    }
    return result.promocodeByCode?.data ? result.promocodeByCode : null;
  });

  useEffect(() => {
    applyPromo();
  }, []);

  /*
    promo: {
      applying: false,
      applied: false,
      code: null,
      details: null, // from server
    }
  */
  const promo = bookState.promo;
  // console.log("PROMO:", promocodeByCode);

  return (
    <div>
      <Typography variant="body1">Apply a Promo Code</Typography>
      <div>
        <Grid container spacing={1} alignItems="center">
          <Grid item style={{ flex: 1 }}>
            <TextField
              placeholder="Enter Code Here"
              value={bookState.m.coupon}
              onChange={setCoupon}
              fullWidth
              size="small"
              margin="dense"
            />
          </Grid>
          <Grid item>
            <Button
              style={{ width: 120 }}
              onClick={applyPromo}
              variant={promo.applying ? "default" : "outlined"}
            >
              {promo.applying ? "Loading..." : "Apply"}
            </Button>
          </Grid>
        </Grid>
      </div>
      {promo.details ? (
        <Alert color="success">Applied Code: {promo.code}</Alert>
      ) : promo.applying ? null : (
        <Alert color="error">Invalid promocode</Alert>
      )}
    </div>
  );
};

export default Promocode;
